import React, { useState } from "react";
import { Send, Loader2, CheckCircle2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function DevotionalResponse({ devotionalId }) {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (message.trim().length < 3) {
      toast.error("Escreva sua reflexão para enviar.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/devotional-reply", {
        devotional_id: devotionalId || null,
        name: name.trim() || null,
        message: message.trim(),
      });
      setDone(true);
    } catch {
      toast.error("Não foi possível enviar agora. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        data-testid="devotional-reply-success"
        className="mt-20 bg-cream border border-[#E5E7EB] px-8 md:px-12 py-14 text-center"
      >
        <CheckCircle2
          size={32}
          strokeWidth={1.5}
          className="text-[#C5A059] mx-auto"
        />
        <p className="mt-6 eyebrow">Recebido</p>
        <p className="mt-5 font-serif-display text-[1.5rem] md:text-[1.75rem] text-[#0B1E36] italic leading-[1.35] tracking-[-0.012em] max-w-xl mx-auto">
          "Sua palavra foi guardada. Que Deus continue falando ao seu coração."
        </p>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid="devotional-reply-form"
      className="mt-20 bg-cream border border-[#E5E7EB] p-8 md:p-10"
    >
      <p className="eyebrow">Resposta pessoal</p>
      <h3 className="mt-5 font-serif-display text-[#0B1E36] text-[1.75rem] md:text-[2.1rem] leading-[1.18] tracking-[-0.018em] font-medium">
        O que Deus falou com você hoje?
      </h3>
      <p className="mt-4 text-[0.98rem] text-[#6B7280] leading-[1.75] font-light">
        Registre a reflexão que ficou no seu coração. Esse pequeno exercício
        ajuda a alma a lembrar daquilo que Deus revelou.
      </p>

      <div className="mt-8">
        <Label
          htmlFor="reply-name"
          className="text-[0.7rem] uppercase tracking-[0.22em] text-[#0B1E36] font-medium"
        >
          Seu nome (opcional)
        </Label>
        <Input
          id="reply-name"
          data-testid="reply-input-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Como devemos te chamar?"
          className="mt-2 rounded-none h-12 border-[#E5E7EB] bg-white focus-visible:border-[#C5A059] focus-visible:ring-0"
        />
      </div>
      <div className="mt-6">
        <Label
          htmlFor="reply-msg"
          className="text-[0.7rem] uppercase tracking-[0.22em] text-[#0B1E36] font-medium"
        >
          Sua reflexão
        </Label>
        <Textarea
          id="reply-msg"
          data-testid="reply-input-message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Escreva livremente. Não há certo ou errado."
          rows={5}
          className="mt-2 rounded-none border-[#E5E7EB] bg-white focus-visible:border-[#C5A059] focus-visible:ring-0 resize-none py-4"
        />
      </div>
      <button
        type="submit"
        disabled={loading}
        data-testid="reply-submit"
        className="btn-primary-gold w-full mt-8 disabled:opacity-60"
      >
        {loading ? (
          <Loader2 size={16} strokeWidth={1.5} className="animate-spin" />
        ) : (
          <>
            <Send size={14} strokeWidth={1.5} />
            Enviar reflexão
          </>
        )}
      </button>
    </form>
  );
}
